import { IUser } from "../other/user.interface";

export type INotifications = INotification[];

export interface INotification {
  notificationText: string;
  modifiedDate: string;
  createdDate: string;
  userInfo: IUser;
  blockId: string;
  templateId: string;
  notificationId?: string;
  replys?: IReplys;
  xCords: number;
  yCords: number;
  pinId: string;
  version?: number | null;
  xPercent?: number | null;
  yPercent?: number | null;
  completed?: boolean;
  completedBy?: IUser | null;
  completedDate?: string | null;
}


export interface IUpdateNotification {
  userInfo?: IUser;
  notificationText?: string;
}

export type IReplys = IReply[];

export interface IReply {
  replyId?: string;
  replyText: string;
  userInfo: IUser;
  modifiedDate?: string;
}

export class NotificationInitVariables implements INotification {
  templateId = '';
  blockId = '';
  userInfo: IUser = {
    username: '',
    name: ''
  };
  notificationText = '';
  xCords = 0;
  yCords = 0;
  pinId = '';
  replys: IReplys = [];
  notificationId = '';
  createdDate = '';
  modifiedDate = '';
}

export interface ISetNotificationCompleted { completed: boolean; userInfo: IUser; }
export interface IUpdateNotificationPin { blockId: string; xPercent: number; yPercent: number; userInfo: IUser; }
export interface IUpdateReply { replyText: string; userInfo: IUser; }
